import { defaultPresets } from "./viewPreset";

/**
 * Scheduler の設定を fiscalStartMonth・fiscalYear に基づいて生成
 * @returns {object} schedulerConfig
 */
export function createSchedulerConfig() {
  return {
    presets: defaultPresets,
    viewPreset: "day",
    rowHeight: 50,
    stripeFeature: true,
    dependenciesFeature: false,
    dependencyEditFeature: false,
    percentBarFeature: false,
    timeRangesFeature: true,
    treeFeature: { disabled: false, expandOnCellClick: true },
    zoomOnMouseWheel: false,
    cellTooltipFeature: true,
    filterFeature: false,
    sortFeature: false,
    timeAxisHeaderMenuFeature: false,
    timeSpanHighlightFeature: true,
    loadMaskError: false,
    zoomOnTimeAxisDoubleClick: false,
    eventSelectionDisabled: true,
    eventCopyPasteFeature: false,
    scheduleMenuFeature: false,
  };
}
